// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rTNwj","left":"styles_left__2CFFZ"};